import { render, staticRenderFns } from "./VoyageListCard.vue?vue&type=template&id=2ca2d23b&scoped=true&"
import script from "./VoyageListCard.vue?vue&type=script&lang=js&"
export * from "./VoyageListCard.vue?vue&type=script&lang=js&"
import style0 from "./VoyageListCard.vue?vue&type=style&index=0&id=2ca2d23b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2d23b",
  null
  
)

export default component.exports